module.exports = __webpack_public_path__ + "static/desktop/img/photobook-2-thumb.8b942b08.png";